import { AppConfig } from "../../models/AppConfig";

export function getOpsViewerScopes(): string[] {
    const subtenant = AppConfig.GLOBAL_CONFIG.tenant.split('.')[0];
    return ['openid', 'profile', `https://${subtenant}.onmicrosoft.com/web/read`];
}